// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d9q_","newExpiryDate":"styles_newExpiryDate__1I3Pa","footer":"styles_footer__1acmJ"};